"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _links = require("../_utils/links");
var _styles = require("@material-ui/core/styles");
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _clsx = _interopRequireDefault(require("clsx"));
var _useIntersectionObserver = require("../_utils/useIntersectionObserver");
var _reactStorage = require("react-storage");
var _commonUtils = require("@sial/common-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
var PromoBanner = function PromoBanner(props) {
  var altText = props.altText,
    anchorId = props.anchorId,
    bgColor = props.bgColor,
    ctaText = props.ctaText,
    descText = props.descText,
    imgLarge = props.imgLarge,
    imgMedium = props.imgMedium,
    imgSmall = props.imgSmall,
    imgExtraSmall = props.imgExtraSmall,
    imgMobile = props.imgMobile,
    linkUrl = props.linkUrl,
    linkNoFollow = props.linkNoFollow,
    promoStyle = props.promoStyle,
    headlineTextColor = props.headlineTextColor,
    descriptionTextColor = props.descriptionTextColor,
    titleText = props.titleText,
    _props$promotionCreat = props.promotionCreative,
    promotionCreative = _props$promotionCreat === void 0 ? '' : _props$promotionCreat,
    _props$promotionId = props.promotionId,
    promotionId = _props$promotionId === void 0 ? '' : _props$promotionId,
    _props$promotionName = props.promotionName,
    promotionName = _props$promotionName === void 0 ? '' : _props$promotionName;
  var baseClass = 'aem-ms-promo-banner';
  var followObj = linkNoFollow ? {
    rel: 'nofollow'
  } : {};
  var linkProps = linkUrl ? (0, _links.getTarget)(linkUrl, followObj) : linkUrl;
  var theme = (0, _styles.useTheme)();
  var mediaQueryMdUp = (0, _useMediaQuery.default)(theme.breakpoints.up('md'));
  var _useState = (0, _react.useState)(false),
    bannerVisible = _useState[0],
    setBannerVisible = _useState[1];
  var _useState2 = (0, _react.useState)(true),
    imageLoading = _useState2[0],
    setImageLoading = _useState2[1];
  var isBentoBanner = imgMedium || imgSmall || imgExtraSmall;
  var isBrowser = typeof window !== 'undefined';
  var isMobile = isBrowser && window.outerWidth <= 600;
  var isGTMEnabled = function isGTMEnabled() {
    var _window;
    return !!(isBrowser && (_window = window) !== null && _window !== void 0 && _window.dataLayer);
  };
  var promoBannerItemsView = function promoBannerItemsView(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && isBentoBanner && !bannerVisible) {
        var getStoredBanners = _reactStorage.sessionStorage.getItem('HOMEPAGE_BANNERS') || [];
        if (getStoredBanners && getStoredBanners !== null && getStoredBanners !== void 0 && getStoredBanners.length) {
          var payload = {
            event: 'view_promotion',
            ecommerce: {
              creative_slot: 'bento_banner - homepage',
              items: (0, _toConsumableArray2.default)(getStoredBanners)
            }
          };
          _commonUtils.Analytics.sendEvent({
            payload: payload
          }, true, isGTMEnabled());
          setBannerVisible(false);
          _reactStorage.sessionStorage.removeItem('HOMEPAGE_BANNERS');
        }
      }
    });
  };
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.75
  };
  var bannerRef = (0, _useIntersectionObserver.useIntersectionObserver)(promoBannerItemsView, options);
  var handleBannerClick = function handleBannerClick() {
    var payload = {
      event: 'select_promotion',
      ecommerce: {
        creative_slot: 'bento_banner - homepage',
        items: [{
          creative_name: promotionCreative,
          promotion_id: promotionId,
          promotion_name: promotionName,
          index: 1,
          item_id: undefined,
          item_brand: undefined,
          item_list_id: 'homepage',
          item_list_name: 'homepage'
        }]
      }
    };
    _commonUtils.Analytics.sendEvent({
      payload: payload
    }, true, isGTMEnabled());
  };
  var getColumnClass = function getColumnClass() {
    if (mediaQueryMdUp) {
      if (imgLarge) return 'col-12';
      if (imgMedium) return 'col-8';
      if (imgSmall) return 'col-6';
      if (imgExtraSmall) return 'col-4';
    }
    if (isMobile && imgMobile) return 'col-mobile';
    return '';
  };
  (0, _react.useEffect)(function () {
    var img = new Image();
    if (isMobile) img.src = imgMobile || '';else img.src = imgLarge || imgMedium || imgSmall || imgExtraSmall || '';
    if (img.src.length) {
      // Check if the image is already loaded (cached)
      if (img.complete) setImageLoading(false); // Turn off loader if image is cached
      else {
        img.onload = function () {
          return setImageLoading(false);
        }; // Turn off loader when the image loads
        img.onerror = function () {
          return setImageLoading(false);
        }; // Turn off loader if image fails to load
      }
    }
  }, [imgLarge, imgMedium, imgSmall, imgExtraSmall, imgMobile, isMobile]);
  (0, _react.useEffect)(function () {
    if (isBentoBanner) {
      var storedBanners = _reactStorage.sessionStorage.getItem('HOMEPAGE_BANNERS') || [];
      var payload = {
        creative_name: promotionCreative,
        promotion_id: promotionId,
        promotion_name: promotionName,
        index: storedBanners.length + 1,
        item_id: undefined,
        item_brand: undefined,
        item_list_id: 'homepage',
        item_list_name: 'homepage'
      };
      _reactStorage.sessionStorage.setItem('HOMEPAGE_BANNERS', [].concat((0, _toConsumableArray2.default)(storedBanners), [payload]));
    }
    return function () {
      _reactStorage.sessionStorage.removeItem('HOMEPAGE_BANNERS');
    };
  }, [isBentoBanner, promotionCreative, promotionId, promotionName]);
  return __jsx("div", {
    id: anchorId,
    className: (0, _clsx.default)('aem-ms-cmp', baseClass, promoStyle, imageLoading && 'banner-skeleton', getColumnClass()),
    style: {
      backgroundColor: bgColor
    },
    ref: bannerRef
  }, __jsx("a", (0, _extends2.default)({
    href: linkUrl
    // @ts-ignore - custom html attribute
  }, linkProps, {
    ga_product: "".concat(promotionId, "|").concat(promotionName, "|").concat(promotionCreative),
    style: {
      backgroundImage: mediaQueryMdUp ? "url(".concat(imgLarge || imgMedium || imgSmall || imgExtraSmall, ")") : 'none'
    },
    onClick: handleBannerClick
  }), __jsx("img", {
    src: imgMobile || imgLarge || imgMedium || imgSmall || imgExtraSmall,
    alt: altText,
    className: "".concat(baseClass, "--image img-mobile")
  }), __jsx("div", {
    className: "".concat(baseClass, "--content")
  }, titleText && __jsx("div", {
    className: "".concat(baseClass, "--title ").concat(headlineTextColor || 'cmp--hero-black'),
    dangerouslySetInnerHTML: {
      __html: titleText
    }
  }), descText && __jsx("div", {
    className: "".concat(baseClass, "--desc ").concat(descriptionTextColor || 'cmp--hero-black'),
    dangerouslySetInnerHTML: {
      __html: descText
    }
  }), ctaText && __jsx("div", {
    className: "".concat(baseClass, "--cta"),
    dangerouslySetInnerHTML: {
      __html: ctaText
    }
  }))));
};
var PromoBannerConfig = {
  emptyLabel: 'Configure Promo Banner Component',
  isEmpty: function isEmpty(props) {
    return !(props.titleText && props.titleText.length > 0 || props.imgLarge);
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/promobanner')(PromoBanner, PromoBannerConfig);
exports.default = _default;